import React, { memo, ReactNode } from 'react'
import { Grid, Typography } from 'transfix-ui/core'

export interface ICarrierRelationshipsModalFormGroupProps {
  label: string
  primaryField: ReactNode
  secondaryField: ReactNode
}

export const CarrierRelationshipsModalFormGroup = memo<ICarrierRelationshipsModalFormGroupProps>(
  ({ label, primaryField, secondaryField }) => (
    <Grid container direction='column' item spacing={1}>
      <Typography gutterBottom>{label}</Typography>
      <Grid item xs={6}>
        {primaryField}
      </Grid>
      <Grid item xs={6}>
        {secondaryField}
      </Grid>
    </Grid>
  )
)
